var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2946(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2946",
    "data-name": "Group 2946",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.701,
    height: 11.701,
    viewBox: "0 0 11.701 11.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M327.8,258.686a5.85,5.85,0,1,1-5.851-5.85,5.85,5.85,0,0,1,5.851,5.85",
    transform: "translate(-316.102 -252.836)",
    fill: "#95a7c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M396.458,326.45h-1.911V324.3a.463.463,0,1,0-.923,0v2.151h-1.911a.509.509,0,0,0,0,1.014h1.911v2.051a.463.463,0,1,0,.923,0v-2.051h1.911a.509.509,0,0,0,0-1.014",
    transform: "translate(-388.066 -321.064)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2946);
export default __webpack_public_path__ + "static/media/Group 2946.50576516a506322dc09023963189ab6e.svg";
export { ForwardRef as ReactComponent };